export const ID_STELLA_MICHELIN = 142;
export const ID_TERRITORIO_DEFAULT = 1000;
export const ID_FILTER_DEFAULT = 1000;
